module.exports = __webpack_public_path__ + "static/6305-woodrose-41-08e483f575c7d23ef9a248a443943d07.jpg";